<template>
  <div class="component-modal" id="modal">
    <form class="form" v-on:submit.prevent>
      <legend>{{$t("left_menu.report.generation_report")}}</legend>
      <i class="material-icons icon" @click.stop.prevent="closeModal">close</i>
      
      <div class="component-modal__row">
        <label for="program">{{$t("modal.spot_programming.spot.generate_block.station")}}
          <small v-if="submitted && v$.model.stationId.$invalid" class="pill-required">* {{ $t("modal.common.required") }}</small>
          <small v-else>*</small>
        </label>
        <div class="component-modal__row">
          <template v-for="station in listStations" :key="station.id">
            <div class="component-modal-radio">
              <label :for="station.id">
                <input type="radio" :name="station.id" :id="station.id" :value="station.id" v-model="model.stationId">
                {{ station.name }}
              </label>
            </div>
          </template>              
        </div>
      </div>

      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <input type="date" v-model="model.dateFrom" @change="validate()" :class="{'invalid': submitted && (v$.model.dateFrom.$invalid || errorTime)}">
          <label for="start">{{$t("modal.spot_programming.spot.generate_block.date_from")}}
            <small v-if="submitted && v$.model.dateFrom.$invalid" class="pill-required">* {{ $t("modal.common.required") }}</small>
            <small v-else>*</small>
          </label>
        </div>
      </div>

      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <input type="date" v-model="model.dateTo" @change="validate()" :class="{'invalid': submitted && (v$.model.dateTo.$invalid || errorTime)}">
          <label for="end">{{$t("modal.spot_programming.spot.generate_block.date_to")}}
            <small v-if="submitted && v$.model.dateTo.$invalid" class="pill-required">* {{ $t("modal.common.required") }}</small>
            <small v-else>*</small>
          </label>
        </div>
      </div>

      <!-- Alert validation -->
      <div class="alert warning" v-if="errorTime">
        <i class="material-icons">info_outline</i>
        {{$t("modal.station_config.schedules.errorDate")}}
      </div>
    
      <div class="component-modal__row">
        <button type="button" @click.stop.prevent="saveAndClose">
          {{$t("modal.confirm")}}
        </button>
        <button type="button" class="button-cancel" @click.stop.prevent="closeModal">
          {{$t("modal.cancel")}}
        </button>
      </div>

      <div class="component-modal__row" v-if="submitted && v$.model.$invalid">
        <div class="modal__form-error">
          <i class="material-icons">info_outline</i>
          <span v-html="$t('modal.common.required_message', {inputs : v$.model.$silentErrors.map(error => $t(`modal.spot_programming.spot.generate_block.${error.$property == 'dateFrom' ? 'date_from' : error.$property == 'dateTo' ? 'date_to' : 'station'}`)).join(', ')})"></span>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { computed, onMounted, ref } from '@vue/runtime-core';
import { required } from '@vuelidate/validators';
import { useStore } from 'vuex';
import moment from 'moment';
import useVuelidate from '@vuelidate/core';
import { useRoute, useRouter } from 'vue-router';

export default {
  setup() {
		const v$ = useVuelidate();
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const listStations = computed(() => store.getters.station_stations({name: ''}));
    const errorTime = ref(false);
    const submitted = ref(false);
    const model = ref({
      stationId: '',
      dateFrom: moment().format("YYYY-MM-DD"),
      dateTo: moment().format("YYYY-MM-DD")
    })

    onMounted(async () => {
      await store.dispatch('station_getAll');
    });

    async function closeModal() {
      await store.dispatch('modal_setActive');
      submitted.value = false;
    }

    async function saveAndClose() {
      submitted.value = true;
      if (!v$.value.model.$invalid && !errorTime.value) {
        store.dispatch('loading_setActive', true);

        try {
          const tab = store.getters.tabs_getActive;
          const tabResult = {
            module: 'report',
            name: 'generation_report',
            stationId: model.value.stationId,
            dateFrom: model.value.dateFrom,
            dateTo: model.value.dateTo,
            id: new Date().getUTCMilliseconds(),
            extendedData: {
              tabActive: tab,
              urlTab: route.path
            }
          }
          await store.dispatch('tabs_addTab', tabResult);
          await store.dispatch('tabs_setActive', tabResult);
          router.push(`/report/generation_report/${tabResult.stationId}/${tabResult.dateFrom}/${tabResult.dateTo}/${tabResult.id}`);
          this.closeModal();
          store.dispatch('loading_setActive', false);
        } catch (error) {
          console.error(error);
          store.dispatch('loading_setActive', false);
        }
      }
    }

    function validate() {
      if (model.value.dateFrom != '' && model.value.dateTo != '') {
        // Si son la misma fecha no validar
        if (model.value.dateFrom == model.value.dateTo) {
          errorTime.value = false;
          return;
        }
        // Validar que start sea previo a end
        if (moment(model.value.dateFrom).isAfter(model.value.dateTo)) {
          model.value.dateTo = model.value.dateFrom;
        }
        // errorTime.value = moment(model.value.dateFrom).isAfter(model.value.dateTo);
      }
    }

    return {
      v$,
      listStations,
      model,
      submitted,
      errorTime,
      saveAndClose,
      closeModal,
      validate
    }
  },
	validations () {
    return {
      model: {
        stationId: {required},
        dateFrom: {required},
        dateTo: {required}
			}
    }
  }
};
</script>